import moment from 'moment';

const data = {
  data: [
    {
      date: moment('2022-02-07T04:00:00.000Z').utc(),
      page: 1,
      beforeOpenTitle: 'mazelDefineBeforeOpenTitle',
      afterOpenTitle: 'mazelDefineAfterOpenTitle',
      afterOpenTopBubble: require('assets/images/bubble/bubble_mazel_define_top.png'),
      afterOpenTopBubbleEng: require('assets/images/bubble/bubble_mazel_define_top_eng.png'),
      afterOpenBottomBubble: require('assets/images/bubble/bubble_mazel_define_bottom.png'),
      afterOpenBottomBubbleEng: require('assets/images/bubble/bubble_mazel_define_bottom_eng.png'),
      themes: [
        {
          previewImageUrl: require('assets/images/theme/preview_mazelDefine_1.gif'),
          beforeOpenThemeName: 'mazelDefine1BeforeOpenThemeName',
          afterOpenThemeName: 'mazelDefine1AfterOpenThemeName',
          characterImage: [require('assets/images/theme/ip_butter_cream_1.png')],
          themeId: 'MILDA0-L-12',
          themeUrl: 'https://share.plkey.app/FyJK',
        },
        {
          previewImageUrl: require('assets/images/theme/preview_mazelDefine_2.gif'),
          beforeOpenThemeName: 'mazelDefine2BeforeOpenThemeName',
          afterOpenThemeName: 'mazelDefine2AfterOpenThemeName',
          characterImage: [require('assets/images/theme/ip_butter_cream_1.png')],
          themeId: 'MILDA0-L-13',
          themeUrl: 'https://share.plkey.app/wrXc',
        },
      ],
    },
    {
      date: moment('2022-02-08T04:00:00.000Z').utc(),
      page: 2,
      beforeOpenTitle: 'butter&creamBeforeOpenTitle',
      afterOpenTitle: 'butter&creamAfterOpenTitle',
      afterOpenTopBubble: require('assets/images/bubble/bubble_butter_cream_top.png'),
      afterOpenTopBubbleEng: require('assets/images/bubble/bubble_butter_cream_top_eng.png'),
      afterOpenBottomBubble: require('assets/images/bubble/bubble_butter_cream_bottom.png'),
      afterOpenBottomBubbleEng: require('assets/images/bubble/bubble_butter_cream_bottom_eng.png'),
      themes: [
        {
          previewImageUrl: require('assets/images/theme/preview_butter_cream.gif'),
          beforeOpenThemeName: 'butter&creamBeforeOpenThemeName',
          afterOpenThemeName: 'butter&creamAfterOpenThemeName',
          characterImage: [
            require('assets/images/theme/ip_butter_cream_1.png'),
            require('assets/images/theme/ip_butter_cream_2.png'),
          ],
          themeId: 'MACOV6-K-6',
          themeUrl: 'https://share.plkey.app/A9L9',
        },
      ],
    },
    {
      date: moment('2022-02-09T04:00:00.000Z').utc(),
      page: 3,
      beforeOpenTitle: 'yourEmotion1BeforeOpenTitle',
      afterOpenTitle: 'yourEmotion1AfterOpenTitle',
      afterOpenTopBubble: require('assets/images/bubble/bubble_yourEmotion_1_top.png'),
      afterOpenTopBubbleEng: require('assets/images/bubble/bubble_yourEmotion_1_top_eng.png'),
      afterOpenBottomBubble: require('assets/images/bubble/bubble_yourEmotion_1_bottom.png'),
      afterOpenBottomBubbleEng: require('assets/images/bubble/bubble_yourEmotion_1_bottom_eng.png'),
      themes: [
        {
          previewImageUrl: require('assets/images/theme/preview_yourEmotion_1(1).gif'),
          beforeOpenThemeName: 'yourEmotion1_1BeforeOpenThemeName',
          afterOpenThemeName: 'yourEmotion1_1AfterOpenThemeName',
          characterImage: [require('assets/images/theme/ip_yourEmotion_1(1).png')],
          themeId: 'YE0-L-7',
          themeUrl: 'https://share.plkey.app/yYd4',
        },
        {
          previewImageUrl: require('assets/images/theme/preview_yourEmotion_1(2).gif'),
          beforeOpenThemeName: 'yourEmotion1_2BeforeOpenThemeName',
          afterOpenThemeName: 'yourEmotion1_2AfterOpenThemeName',
          characterImage: [require('assets/images/theme/ip_yourEmotion_1(2).png')],
          themeId: 'YE0-L-6',
          themeUrl: 'https://share.plkey.app/oMgT',
        },
      ],
    },
    {
      date: moment('2022-02-10T04:00:00.000Z').utc(),
      page: 4,
      beforeOpenTitle: 'yourEmotion2BeforeOpenTitle',
      afterOpenTitle: 'yourEmotion2AfterOpenTitle',
      afterOpenTopBubble: require('assets/images/bubble/bubble_yourEmotion_2_top.png'),
      afterOpenTopBubbleEng: require('assets/images/bubble/bubble_yourEmotion_2_top_eng.png'),
      afterOpenBottomBubble: require('assets/images/bubble/bubble_yourEmotion_2_bottom.png'),
      afterOpenBottomBubbleEng: require('assets/images/bubble/bubble_yourEmotion_2_bottom_eng.png'),
      themes: [
        {
          previewImageUrl: require('assets/images/theme/preview_yourEmotion_2(1).gif'),
          beforeOpenThemeName: 'yourEmotion2_1BeforeOpenThemeName',
          afterOpenThemeName: 'yourEmotion2_1AfterOpenThemeName',
          characterImage: [require('assets/images/theme/ip_yourEmotion_2(1).png')],
          themeId: 'YE0-L-9',
          themeUrl: 'https://share.plkey.app/KJbR',
        },
        {
          previewImageUrl: require('assets/images/theme/preview_yourEmotion_2(2).gif'),
          beforeOpenThemeName: 'yourEmotion2_2BeforeOpenThemeName',
          afterOpenThemeName: 'yourEmotion2_2AfterOpenThemeName',
          characterImage: [require('assets/images/theme/ip_yourEmotion_2(2).png')],
          themeId: 'YE0-L-8',
          themeUrl: 'https://share.plkey.app/Mqmb',
        },
      ],
    },
  ],
};

export default data;
